export default "__VITE_ASSET__HzIHKkj___"